import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'go-top-component',
    templateUrl: './go-top.component.html',
})
export class GoToTopComponent{
    environment: any;
    constructor() {
      this.environment = environment;
    }
    ngOnInit() {
        window.addEventListener('scroll', this.scrollFunction, true);
      }
    
    
      ngOnDestroy() {
          window.removeEventListener('scroll', this.scrollFunction, true);
      }

    gototop(){
        (function smoothscroll() {
          var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
          if (currentScroll > 0) {
              window.requestAnimationFrame(smoothscroll);
              window.scrollTo(0, currentScroll - (currentScroll / 8));
          }
      })();
      }
       scrollFunction() {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
          document.getElementById("myBtn").style.display = "block";
        } else {
          document.getElementById("myBtn").style.display = "none";
        }
      }

}